module.exports = __webpack_public_path__ + "static/media/x2.1f72daa9.jpg";